export default "/images/vendor/intl-tel-input/build/flags@2x.png?276410ffdcdd2ff8dca2477e71874903";